var outputAlphaPS = `
gl_FragColor.a = litArgs_opacity;
`;

export { outputAlphaPS as default };
